'use client';

import React, { useState } from 'react';
import { Navbar } from '@/components/landing/Navbar';
import { Footer } from '@/components/landing/Footer';
import DemoModal from '@/components/DemoModal';

export function BlogLayout({ children }: { children: React.ReactNode }) {
    const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);

    const jsonLd = {
        '@context': 'https://schema.org',
        '@type': 'BlogPosting',
        headline: 'Axist Blog',
        description: 'Read the latest updates and insights from Axist.',
        author: {
            '@type': 'Organization',
            name: 'Axist',
            url: 'https://axist.app'
        },
        publisher: {
            '@type': 'Organization',
            name: 'Axist',
            logo: {
                '@type': 'ImageObject',
                url: 'https://axist.app/axist.png'
            }
        },
        mainEntityOfPage: {
            '@type': 'WebPage',
            '@id': 'https://axist.app/blog'
        }
    };

    return (
        <div className="min-h-screen bg-white text-gray-900 font-sans selection:bg-orange-100 selection:text-orange-900 flex flex-col">
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
            />
            <Navbar onDemoClick={() => setIsDemoModalOpen(true)} />

            {children}

            <Footer />

            <DemoModal
                isOpen={isDemoModalOpen}
                onClose={() => setIsDemoModalOpen(false)}
            />
        </div>
    );
}
